import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { tenantApi } from '../api/tenantApi';

const ReadOnlyContext = createContext({ isReadOnly: false, tenantStatus: 'active' });

export function ReadOnlyProvider({ children }) {
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [tenantStatus, setTenantStatus] = useState('active');

  const checkStatus = useCallback(async () => {
    try {
      const data = await tenantApi.getMyProfile();
      const readOnly = data?.isReadOnly || data?.tenant?.isReadOnly || false;
      setIsReadOnly(readOnly);
      setTenantStatus(data?.tenant?.status || 'active');
    } catch {
      // If we can't fetch, assume not read-only
    }
  }, []);

  useEffect(() => { checkStatus(); }, [checkStatus]);

  return (
    <ReadOnlyContext.Provider value={{ isReadOnly, tenantStatus }}>
      {children}
    </ReadOnlyContext.Provider>
  );
}

export function useReadOnly() {
  return useContext(ReadOnlyContext);
}
